// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"form-section_subtitle__fn7Sz"};